import { render, staticRenderFns } from "./AssignSlot.vue?vue&type=template&id=458ac8e5&scoped=true&lang=pug&"
import script from "./AssignSlot.vue?vue&type=script&lang=js&"
export * from "./AssignSlot.vue?vue&type=script&lang=js&"
import style0 from "./AssignSlot.vue?vue&type=style&index=0&id=458ac8e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458ac8e5",
  null
  
)

export default component.exports